import { render, staticRenderFns } from "./PwForceChange.vue?vue&type=template&id=c9ec8b82&scoped=true&"
import script from "./PwForceChange.vue?vue&type=script&lang=js&"
export * from "./PwForceChange.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/login.css?vue&type=style&index=0&id=c9ec8b82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9ec8b82",
  null
  
)

export default component.exports